import React from "react";
import {
  Box,
  Flex,
  Heading,
  Text,
  Stack
} from "@chakra-ui/core";
import DashboardMockup from "../mockups/dashboard/DashboardMockup"
import CallToAction from "../elements/CallToAction"

function LandingSectionFive() {
  return (
    <Box bg="#fff" py={["48px","60px","72px","76px"]} pb="40px" w="100%">
      <Flex maxW="1280px" m="auto" w="100%">
        <Box minWidth="340px" w="100%" px="16px" m="auto">
          <Box textAlign="center" m="auto" w="100%" maxW="2xl">
            <Heading
              color="primary.500"
              as="h1"
              size="xl"
              lineHeight="shorter"
              fontWeight="bolder"
              m={0}
            >
              Stay in control <br/> with your dasboard
            </Heading>

            <Text opacity="0.7" color="primary.500" fontSize="lg" mt="2">
            Once you’re set up, you can create and manage orders and payouts, view detailed financial reports, and create links all directly from the Dashboard. 
            </Text>
            <Stack m="auto" justifyContent="center" isInline my="12px">
          <CallToAction />
          </Stack>

          </Box>
        </Box>
      </Flex>
      <Flex maxW="1490px" flexWrap="wrap-reverse" m="auto" w="100%">
    <Box
        w="100%"
      >
        {/* <ScreenMockup perspective="none" section="dashboard" size="large" /> */}
        <Box p={["12px","28px","28px","28px"]}>
        <DashboardMockup />
        </Box>
        
      </Box>

    </Flex>

    </Box>
  );
}

export default LandingSectionFive;
